// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"131":"5565c99a","298":"ee91cd0f","385":"18d08f82","453":"63c4db86","585":"5f853f81","592":"1fffe65c","668":"422a175d","680":"8d74ff95","871":"03667fa4","962":"43618c2c"}[chunkId] + ".chunk.js";
};